var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-members"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "members",
    clipPath: "url(#clip-members)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15836",
    "data-name": "Group 15836",
    transform: "translate(7381.039 10457.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15802",
    "data-name": "Group 15802",
    transform: "translate(-7378 -10450.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(21.68 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 4.279,
    cy: 4.279,
    r: 4.279,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M68.336,780.749a7.383,7.383,0,0,0-7.371-7",
    transform: "translate(-56.092 -762.653)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 4.279,
    cy: 4.279,
    r: 4.279,
    transform: "translate(3.685 0)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M44.451,780.749a7.383,7.383,0,0,1,7.371-7",
    transform: "translate(-44.451 -762.653)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15801",
    "data-name": "Group 15801",
    transform: "translate(-7368.835 -10442.861)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-2",
    "data-name": "Ellipse 16",
    cx: 4.279,
    cy: 4.279,
    r: 4.279,
    transform: "translate(3.216)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15800",
    "data-name": "Group 15800",
    transform: "translate(0 11.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231-2",
    "data-name": "Path 231",
    d: "M44.451,780.749a7.383,7.383,0,0,1,7.371-7",
    transform: "translate(-44.451 -773.747)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31641",
    "data-name": "Path 31641",
    d: "M68.336,780.749a7.383,7.383,0,0,0-7.371-7",
    transform: "translate(-53.707 -773.747)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.ae7979390006c4549f630b1eb9d44282.svg";
export { ForwardRef as ReactComponent };